import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {PctConfigModel} from '../../models/pct-config/pct-config.model';
import {Observable} from 'rxjs';
import { EmployeeRoleEnum } from '../../models/employee/employee-role.enum';
import {PctConfigService} from "./pct-config.service";

@Injectable()
export class RemotePctConfigService extends PctConfigService {
    API_URL = '/apiRemConfig/v1';

    constructor(private http: HttpClient) {
        super();
    }

    public findRemConfigByCountryAndRole(country: string, role: EmployeeRoleEnum) : Observable<PctConfigModel[]>{
        const url = `${this.API_URL}/pct/${country}/${role.pricingRole}`;
        return this.http.get<PctConfigModel []>(url);
    }

}
